// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tZCh","left":"styles_left__2qNkm"};